import type { PublicApiKey } from '@/apilib';
import type { createPrivateAppsPanelApi } from './api';

export const PrivateAppsPanelApiKey: PublicApiKey<
  typeof createPrivateAppsPanelApi
> = {
  name: 'PrivateAppsPanelApi',
  public: true,
};
